/**
 * Danger alert icon — red circle with exclamation mark.
 * Used in AlertModal danger variant (delete confirmations, destructive actions).
 */
function AlertDangerIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M12 8v5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="16" r="0.75" fill="currentColor" />
    </svg>
  );
}

export default AlertDangerIcon;
